/** @format */

import React from "react";
import SingleInfo from "./SingleInfo";
import { useAuth } from "../context/AuthContext";
import {
  MdPerson,
  MdTagFaces,
  MdMessage,
  MdFileCopy,
  MdStar,
  MdGroup,
  MdDownload,
  MdPersonOutline,
  MdCamera,
  MdCameraFront,
  MdCreditCard,
} from "react-icons/md";

const ProfileInfo = ({
  description,
  email,
  age,
  firstName,
  lastName,
  otherName,
  url,
  selectClass,
}) => {
  const { setShowModal } = useAuth();

  const handleShowModal = () => {
    setShowModal(true);
  };

  return (
    <div>
      <div className="profile__info__avatar__backdrop">
        <div onClick={handleShowModal} className="profile__info__avatar">
          {url ? <img src={url} alt="" /> : <MdPerson />}
        </div>
      </div>

      <hr />
      <div className="profile__info__gallery">
        <div className="images">
          <MdCamera />
          <span>gallery</span>
        </div>
        <div className="images">
          <MdCreditCard />
          <span>pay fees</span>
        </div>
        <div className="images">
          <MdCameraFront />
          <span>others</span>
        </div>
      </div>
      <hr />

      <div className="profile__info__container">
        <h3 className="profile__info__title">BIO</h3>
        <SingleInfo
          icon={<MdPerson />}
          label="Name"
          description={`${firstName} ${otherName} ${lastName} `}
        />
        <SingleInfo
          icon={<MdTagFaces />}
          description={age ? age : "No info provided"}
          label="Age"
        />
        <SingleInfo
          icon={<MdMessage />}
          label="Email"
          description={email ? email : "No info provided"}
        />

        <h3 className="profile__info__title">SCHOOL RECORD</h3>
        <SingleInfo
          icon={<MdGroup />}
          label="Class"
          description={selectClass ? selectClass : "No info provided"}
        />
        <SingleInfo
          icon={<MdStar />}
          label="Grade"
          description={description ? description : "No info provided"}
        />
        <SingleInfo
          icon={<MdStar />}
          label="Post in School"
          description={description ? description : "No info provided"}
        />
        <SingleInfo
          icon={<MdPersonOutline />}
          label="Form Teacher's Comments"
          description={description ? description : "No Comments Yet..."}
        />
        <SingleInfo
          icon={<MdFileCopy />}
          label="Result"
          description={description ? description : "No Result Yet"}
        />

        <div className="btn">
          <button className="btn profile__info__btn">
            <MdDownload /> Download Result
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileInfo;
